export const TABLE_SETTINGS_CELLS_HEADER_MERGE_SIDE_MERGE = "HEADER_MERGE_SIDE_MERGE";
export const TABLE_SETTINGS_CELLS_HEADER_MERGE_SIDE_SPLIT = "HEADER_MERGE_SIDE_SPLIT";
export const TABLE_SETTINGS_CELLS_HEADER_SPLIT_SIDE_MERGE = "HEADER_SPLIT_SIDE_MERGE";
export const TABLE_SETTINGS_CELLS_HEADER_SPLIT_SIDE_SPLIT = "HEADER_SPLIT_SIDE_SPLIT";
export const TABLE_SETTINGS_CELLS_HEADER_UND_SIDE_UND = "HEADER_UND_SIDE_UND";
